"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = exports.AccountPlan = void 0;
var AccountPlan;
(function (AccountPlan) {
    AccountPlan["FREE"] = "FREE";
    AccountPlan["PREMIUM"] = "PREMIUM";
})(AccountPlan = exports.AccountPlan || (exports.AccountPlan = {}));
var Account = /** @class */ (function () {
    function Account(_a) {
        var id = _a.id, naming = _a.naming, address = _a.address, contact = _a.contact, plan = _a.plan, _b = _a.premiumSince, premiumSince = _b === void 0 ? 0 : _b, _c = _a.issued, issued = _c === void 0 ? 0 : _c;
        this.id = id;
        this.naming = naming;
        this.address = address;
        this.contact = contact;
        this.plan = plan;
        this.premiumSince = premiumSince;
        this.issued = issued;
    }
    return Account;
}());
exports.Account = Account;
//# sourceMappingURL=account.js.map